import { render } from "./CustomDropDown.vue?vue&type=template&id=289d7d84&scoped=true&ts=true"
import script from "./CustomDropDown.vue?vue&type=script&lang=ts"
export * from "./CustomDropDown.vue?vue&type=script&lang=ts"

import "./CustomDropDown.vue?vue&type=style&index=0&id=289d7d84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289d7d84"]])

export default __exports__